export const pureChatPages = [
    "home",
    "silver-membership",
    "gold-membership",
    "shopping",
    "shop",
    "category",
    "subcategory"
]